import React from 'react';
import PropTypes from 'prop-types';
import { Card, Column, GridContainer, Row, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { DateFormatTypes } from '@vp/om-date-formatter';
import useSiteData from '../../../hooks/useSiteData';
import CurrencyWrapper from '../../shared/pricing/CurrencyWrapper';
import { currencyLocaleFormatter } from '../../../util/currencyFormatter';
import Date from '../../shared/Date';

export const MultibancoCard = ({ payment }) => {
  const [paymentMessages] = useTranslations(['paymentMessages']);
  const { locale } = useSiteData();

  return (
    <Card my={3}>
      <GridContainer>
        <Row>
          <Column span={10} offset={1}>
            <Row>
              <Column span={2}>
                <Typography fontWeight="bold">
                  {paymentMessages.amountDueField}
                </Typography>
                <CurrencyWrapper
                  fractionDigits={payment.fractionDigits}
                  typeSize={2}
                  listCents={payment.cents}
                  currencyCode={payment.currencyCode}
                  locale={currencyLocaleFormatter(locale)}
                />
              </Column>
              <Column span={2}>
                <Typography fontWeight="bold">
                  {paymentMessages.dueDateField}
                </Typography>
                <Date
                  date={payment.customerPaymentData.Multibanco.DueDate}
                  dateFormatType={DateFormatTypes.MEDIUM_FMT}
                />
              </Column>
              <Column span={2}>
                <Typography fontWeight="bold">
                  {paymentMessages.paymentDetailsTitle}:
                </Typography>
                <Typography>{payment.paymentMethod}</Typography>
              </Column>
              <Column span={3}>
                <Typography fontWeight="bold">
                  {paymentMessages.multibancoReferenceNumberField}
                </Typography>
                <Typography>
                  {payment.customerPaymentData.Multibanco.ReferenceNumber}
                </Typography>
              </Column>
              <Column span={3}>
                <Typography fontWeight="bold">
                  {paymentMessages.multibancoEntityField}
                </Typography>
                <Typography>
                  {payment.customerPaymentData.Multibanco.EntityId}
                </Typography>
              </Column>
            </Row>
            <Row>
              <Column span={12}>
                <Typography mt={5}>
                  {paymentMessages.multibancoInstructions}
                </Typography>
              </Column>
            </Row>
          </Column>
        </Row>
      </GridContainer>
    </Card>
  );
};

MultibancoCard.propTypes = {
  payment: PropTypes.object.isRequired,
};
